import D2C_Provider from '../Provider'
import store from '@/store'

class D2C_ProviderStorage extends D2C_Provider {
  purpose = 'storage'
  static objectType = 'providerPurpose'
  static purposeName = 'storage'
  static purposeTitle = 'Storage'
  get _services() {
    return store.getters.services.filter(service => service.crons.find(task => task.provider === this.id))
  }
  get _backupPostfix() {
    return ''
  }
}

export default D2C_ProviderStorage
